import { Box } from '#/components/Box/Box';
import type {
  CmsApiSplitBlockAppearance,
  CmsApiSplitBlockText,
} from '#/modules/cms/api/types/blocks/CmsApiSplitContentBlock';
import { gutterWidth } from '#/theme/theme';

import { CmsSplitContentTextContentInner } from './CmsSplitContentTextContentInner';

type Props = {
  section: CmsApiSplitBlockText;
  appearance: CmsApiSplitBlockAppearance;
  index: number;
  blockId: string;
  imageTextBlock: boolean;
  blockIndex: number;
  pageUpdated: string;
  showBackgroundImage: boolean;
};

export function CmsSplitContentTextContent({
  appearance,
  blockId,
  blockIndex,
  imageTextBlock,
  index,
  pageUpdated,
  showBackgroundImage,
  section,
}: Props) {
  const showTextBox = ['FULL_WIDTH', 'OVERLAPPING'].includes(appearance);

  const hideButton =
    section.data.button &&
    // TODO: Fix this from eslint v9 update
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    section.data.button.type === 'CMS_PAGE' &&
    !section.data.button.data.pageTitle;

  return (
    <Box
      qaId={`split-content-section-${index}`}
      // @ts-expect-error TS(2322): Type 'false | 1' is not assignable to type 'Respon... Remove this comment to see the full error message
      zIndex={showTextBox && 1}
      width={[1, null, 1 / 2]}
      px={[imageTextBlock ? null : gutterWidth / 4, null, gutterWidth / 2]}
      py={[
        imageTextBlock ? gutterWidth / 2 : gutterWidth / 4,
        null,
        gutterWidth / 2,
      ]}
      key={blockId}
    >
      <CmsSplitContentTextContentInner
        appearance={appearance}
        blockId={blockId}
        blockIndex={blockIndex}
        index={index}
        pageUpdated={pageUpdated}
        label={section.data.label}
        headline={section.data.headline}
        html={section.data.html}
        button={section.data.button}
        showTextBox={showTextBox}
        hideButton={Boolean(hideButton)}
        showBackgroundImage={showBackgroundImage}
      />
    </Box>
  );
}
